/* eslint-disable react/require-default-props */
/* eslint-disable tailwindcss/no-arbitrary-value */
import React from 'react';
import PropTypes from 'prop-types';
import { Profile } from '@one-thd/sui-icons';
import classNames from 'classnames';

const AssociateIcon = ({
  size = null,
  spacing = '11',
}) => {
  const classes = classNames(
    'sui-flex sui-justify-center sui-items-center sui-rounded-full sui-bg-inverse', {
      'sui-min-w-11 sui-min-h-11': spacing === '11',
      'sui-min-w-8 sui-min-h-8': spacing === '8',
    }
  );
  return (
    <div className={classes} data-component="AssociateIcon">
      <Profile color="inverse" size={size} />
    </div>
  );
};

AssociateIcon.propTypes = {
  size: PropTypes.string,
  spacing: PropTypes.string,
};

export { AssociateIcon };
